import { useState } from "react";
import {
  Container,
  TableRow,
  TableHead,
  TableContainer,
  TableCell,
  TableBody,
  Table,
  IconButton,
} from "@material-ui/core";
import { connect } from "react-redux";
// Redux
import { changeView } from "../../redux/actions/Menu";
import { getPartners, updatePartners } from "../../redux/actions/Partners";
// Componetns
import LoadingData from "../global/LoadingData";
import Pagination from "../global/ButtonsPagination";
// Values
import { Ic_edit, StateView, stateData } from "../../values";
// Styles
import { useStyles } from "../../style";
// Api
import { getData, getOneData } from "../../utils/partners";

const Tables = ({ data, status, token, records, changeView, getPartners, updatePartners }) => {
  const classes = useStyles();
  const [page, setPage] = useState(1);

  const edit = async (item) => {
    const res = await getOneData(item.Id, token);
    if (res.flag) {
      changeView(StateView.state3);
      updatePartners(res.data.Data);
    }
  };

  const GetData = async (page) => {
    const res = await getData(token, `?Page=${page}`);
    getPartners(res.data);
    window.scrollTo(0, 0);
  };
  const changePage = (e, v) => {
    setPage(v);
    GetData(v);
  };
  return (
    <div style={{ position: "relative" }}>
      {status === stateData.state2 ? (
        <Container maxWidth="xl">
          <TableContainer style={{ background: "#fff" }}>
            <Table size="small">
              <TableHead>
                <TableRow style={{ background: "#132327", height: 50 }}>
                  {["Nombre", "Email", "Puesto", "Empresa", "Id", "Editar"].map((item, index) => (
                    <TableCell
                      align="center"
                      key={index}
                      className={classes.table_title3}
                      style={{ fontFamily: "bold", color: "#fff" }}
                    >
                      {" "}
                      {item}{" "}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data &&
                  data.map((item, index) => (
                    <TableRow key={index} style={{ borderBottom: `1px solid #f3f4f7` }}>
                      <TableCell align="center" className={classes.table_text3} style={{ fontFamily: "regular" }}>
                        {item.Name}
                      </TableCell>
                      <TableCell align="center" className={classes.table_text3} style={{ fontFamily: "regular" }}>
                        {item.Email}
                      </TableCell>
                      <TableCell align="center" className={classes.table_text3} style={{ fontFamily: "regular" }}>
                        <span style={{ fontWeight: 700 }}>{item.Rol === "ADMIN" ? "Admin" : "Operador"}</span>
                      </TableCell>
                      <TableCell align="center" className={classes.table_text3} style={{ fontFamily: "regular" }}>
                        {item.Company}
                      </TableCell>
                      <TableCell align="center" className={classes.table_text3} style={{ fontFamily: "regular" }}>
                        {item.CompanyId}
                      </TableCell>
                      <TableCell align="center" className={classes.table_text3}>
                        <IconButton onClick={() => edit(item)}>
                          <img alt="ic_edit" src={Ic_edit} />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination records={records} page={page} changePage={changePage} />
        </Container>
      ) : (
        <LoadingData />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.Partners.partners,
  status: state.Partners.status,
  token: state.Panel.token,
  records: state.Partners.records,
});

export default connect(mapStateToProps, { changeView, getPartners, updatePartners })(Tables);
